// A2-478 — ONE answer to "is there a figure to copy from this box?", shared
// by the bar's count, the card's highlight and "Show only the figures to
// copy", so the three can never disagree (operator 2026-10-21: "inconsistent").
// The figure is the one TYPED on the form: Hungary takes thousands of
// forints, so 400 forints is a 0 there.

export const figureToType = (box, entryScale = 1) => {
  const raw = String(box?.value ?? "").trim();
  const n = Number(raw);
  if (raw === "" || !Number.isFinite(n)) return null;
  return entryScale > 1 ? Math.round(n / entryScale) : n;
};

export const isZeroFigure = (box, entryScale = 1) => figureToType(box, entryScale) === 0;

// a box whose computation failed is never "nothing to copy": its error shows
export const isFigureToCopy = (box, entryScale = 1) =>
  box?.portal === "enter" && !box?.error && !isZeroFigure(box, entryScale);
